import { render } from "./ThunderEggWrapper.vue?vue&type=template&id=69f7dde8&scoped=true&bindings={\"eggId\":\"props\",\"owner\":\"props\",\"lava\":\"props\",\"lpStones\":\"props\",\"birth\":\"props\",\"name\":\"props\",\"age\":\"props\"}"
import script from "./ThunderEggWrapper.vue?vue&type=script&lang=js"
export * from "./ThunderEggWrapper.vue?vue&type=script&lang=js"

import "./ThunderEggWrapper.vue?vue&type=style&index=0&id=69f7dde8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-69f7dde8"

export default script